export default {
  setQuickEditActive(state, isActive) {
    state.quickEditActive = isActive;
  },
  SET_BOOKING(state, booking){
    state.selectedBooking = booking
  }
};
